export * from './get-table-properties';
